import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import SmsNotification from "../../../../../model/notification/sms/SmsNotification";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: SmsNotification
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class IncomingSmsNotificationItem extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.routeToNote = this.routeToNote.bind(this);
	}

	render() {

		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});
		const leadRef = this.props.notification.data.recognizedSmsData.map(rsd => `Lead ${rsd.referenceNumber} `).getOrElse("");

		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icn-act-note.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						{`${leadRef}SMS from ${this.props.notification.displayCreatorName()}`}
					</div>
					<div className={"notification-content"}>
						<span className="d-block">{this.props.notification.displayDate()}</span>
						{this.props.notification.data.smsContent}
					</div>
					{this.renderCTA()}
				</div>
			</div>
		);
	}

	/**
	 * Render call to action buttons.
	 */
	renderCTA() {
		const isRecognized = this.props.notification.data.recognizedSmsData.isDefined;
		return (
			<React.Fragment>
				{isRecognized && <span className="notification-link" onClick={this.routeToNote}>View</span>}
				{isRecognized && <span className="notification-link-separator">|</span>}
				{this.props.notification.read &&
				<span className="notification-link" onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>}
				{!this.props.notification.read &&
				<span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>}
			</React.Fragment>
		)
	}

	/**
	 * Route to proper lead.
	 */
	routeToNote() {
		this.props.notification.data.recognizedSmsData.map(rsd => {
			this.props.history.push(Routes.EditLead(rsd.referenceNumber));
		});
	}

}

export default withRouter<IComponentProps>(IncomingSmsNotificationItem);
